// apps/client/src/client/services/analytics/use-dashboard-metrics.ts

import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import qs from "qs";

export interface DashboardMetrics {
  users: { total: number; new: number; active: number; banned: number };
  payments: { total: number; amount: number; avg: number };
  souscriptions: { active: number; expired: number };
  resumes: { total: number; public: number; private: number };
  downloads: { total: number };
  credits: { totalRemaining: number; totalDistributed: number };
  references: { total: number; bonusTotal: number };
  //coupons: { total: number; active: number; used: number; totalReduction: number };
}

export const fetchDashboardMetrics = async (from?: Date, to?: Date): Promise<DashboardMetrics> => {
  const params = { from: from?.toISOString(), to: to?.toISOString() };
  const response = await axios.get<DashboardMetrics>("/analytics/dashboard", {
    params,
    paramsSerializer: (p) => qs.stringify(p, { skipNulls: true }),
  });
  return response.data;
};

export const useDashboardMetrics = (from?: Date, to?: Date) => {
  return useQuery({
    queryKey: ["dashboardMetrics", from, to],
    queryFn: () => fetchDashboardMetrics(from, to),
  });
};
